/**
 * Key must match `name` in `store.ts` persist middleware (`appStore`).
 */
export const APP_STORE_PERSIST_KEY = 'appStore';

/**
 * Forces `appEvents.activateTotp.remindAt` / `neverShowAgain` to be cleared in the
 * persisted JSON under `appStore`, so the next session (or another tab) does not
 * inherit another user's "remind later" / opt-out state.
 *
 * Zustand persist normally rewrites this on each `set`, but this is a reliable
 * fallback when inspecting localStorage after logout still shows stale values.
 */
export function clearPersistedActivateTotpInLocalStorage(): void {
  if (typeof window === 'undefined') return;
  try {
    const raw = localStorage.getItem(APP_STORE_PERSIST_KEY);
    if (!raw) return;
    const parsed = JSON.parse(raw) as {
      state?: {
        appEvents?: {
          activateTotp?: Record<string, unknown>;
        };
      };
      version?: number;
    };
    if (!parsed.state?.appEvents?.activateTotp) return;
    parsed.state.appEvents.activateTotp = {
      ...parsed.state.appEvents.activateTotp,
      remindAt: null,
      neverShowAgain: false,
    };
    localStorage.setItem(APP_STORE_PERSIST_KEY, JSON.stringify(parsed));
  } catch {
    // ignore malformed storage
  }
}
